import { Component, DestroyRef, TemplateRef, inject, signal, viewChild } from '@angular/core';
import { ErrorReportEvent, ErrorReportService, TokenStorageService } from '@dlap-ui/core';
import { NzNotificationComponent, NzNotificationService } from 'ng-zorro-antd/notification';
import { LodgeTicketModal } from '../lodge-ticket-modal/lodge-ticket-modal';
import { ReportIssueContext } from './report-issue.model';

@Component({
  selector: 'dlap-error-report-host',
  imports: [LodgeTicketModal],
  templateUrl: './error-report-host.html',
})
export class ErrorReportHost {
  private readonly errorReport = inject(ErrorReportService);
  private readonly notification = inject(NzNotificationService);
  private readonly tokenStorage = inject(TokenStorageService);

  private readonly content = viewChild.required<TemplateRef<{ $implicit: NzNotificationComponent; data: ErrorReportEvent }>>('content');

  readonly isReportOpen = signal(false);
  readonly reportContext = signal<ReportIssueContext | null>(null);

  constructor() {
    const unregister = this.errorReport.register((event) => this.show(event));
    inject(DestroyRef).onDestroy(unregister);
  }

  canReport(): boolean {
    return this.tokenStorage.isAuthenticated();
  }

  openReport(event: ErrorReportEvent): void {
    if (!this.canReport()) {
      return;
    }

    this.reportContext.set({
      title: 'Request failed',
      message: event.message,
      metadata: {
        ...(event.url ? { requestUrl: event.url } : {}),
        ...(event.method ? { requestMethod: event.method } : {}),
        ...(event.status !== undefined ? { statusCode: String(event.status) } : {}),
      },
      requestPayload: event.requestPayload,
      responseBody: event.responseBody,
    });
    this.isReportOpen.set(true);
  }

  private show(event: ErrorReportEvent): void {
    this.notification.error('Something went wrong', this.content(), {
      nzData: event,
      nzDuration: 10000,
    });
  }
}
